<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h1 id="account-profile-title">{{ pageTitle$ | async }}</h1>
      </div>

      <ds-tabs tablistLabelledBy="account-profile-title">
        <ds-tab [heading]="''" [label]="'label_details' | translate">
          <app-account-profile></app-account-profile>
        </ds-tab>
        <ds-tab [heading]="''" [label]="'sidebar_menu_account' | translate">
          <app-account-settings [displayHeader]="false"></app-account-settings>
        </ds-tab>
      </ds-tabs>
    </div>
  </div>
</div>
